var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":_vm.$vuetify.breakpoint.mobile}},[_c('v-col',{staticClass:"pt-1",attrs:{"cols":"12"}},[_c('code-input',{attrs:{"solo":""}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('event-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }